import Cookies from 'js-cookie'

import { CookieSettings } from '@cookieManage/types/CookieManage.interface'

/**
 * Set the cookie settings on body as a search param
 */
export function setBodyCookieSettings(settings: CookieSettings) {
  $(document.body).attr('data-cookies-settings', getCookiesSettingsUrl(settings))
}

function getCookiesSettingsUrl(settings: CookieSettings) {
  const cookiePermission = Cookies.get('cookie_permission')
  const encodedCookieSettings = `cookie_settings=${encodeURIComponent(JSON.stringify(settings))}`

  let cookiesSettingsUrl = encodedCookieSettings

  if (cookiePermission) {
    const encodedCookiePermission = encodeURIComponent(cookiePermission)
    cookiesSettingsUrl = `${cookiesSettingsUrl}&cookie_permission=${encodedCookiePermission}`
  }

  return cookiesSettingsUrl
}

/**
 * get the cookie settings on body as a search param
 */
export function getBodyCookieSettings() {
  const cookieSettingsUrl = $(document.body).attr('data-cookies-settings')

  return cookieSettingsUrl
}
